// TimeEnum utility for generating time options from 12:00 AM to 11:45 PM
export const generateTimeOptions = () => {
  const times = [];

  // Generate times from 12:00 AM to 11:45 PM
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const timeString = formatTime(hour, minute);
      times.push(timeString);
    }
  }

  return times;
};

// Format hour and minute to 12-hour format with AM/PM
const formatTime = (hour, minute) => {
  let displayHour = hour;
  let ampm = "AM";

  if (hour === 0) {
    displayHour = 12;
  } else if (hour === 12) {
    ampm = "PM";
  } else if (hour > 12) {
    displayHour = hour - 12;
    ampm = "PM";
  }

  const minuteStr = minute.toString().padStart(2, "0");
  return `${displayHour}:${minuteStr} ${ampm}`;
};

// Convert time string to minutes for comparison
export const timeToMinutes = (timeString) => {
  if (!timeString) return 0;

  const [time, ampm] = timeString.split(" ");
  const [hour, minute] = time.split(":").map(Number);

  let totalMinutes = hour * 60 + minute;

  if (ampm === "PM" && hour !== 12) {
    totalMinutes += 12 * 60;
  } else if (ampm === "AM" && hour === 12) {
    totalMinutes -= 12 * 60;
  }

  return totalMinutes;
};

// Calculate duration between two times
export const calculateDuration = (startTime, endTime) => {
  if (!startTime || !endTime) return null;

  const startMinutes = timeToMinutes(startTime);
  const endMinutes = timeToMinutes(endTime);

  if (endMinutes <= startMinutes) return null;

  const diffMinutes = endMinutes - startMinutes;
  const hours = Math.floor(diffMinutes / 60);
  const minutes = diffMinutes % 60;

  if (hours === 0) {
    return `${minutes} min`;
  } else if (minutes === 0) {
    return `${hours} hr`;
  } else {
    return `${hours} hr ${minutes} min`;
  }
};
